/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Pie: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M14 0H13V11H24V10C24 4.5 19.5 0 14 0Z' fill='currentColor' />
    <path d='M11 4H10C4.5 4 0 8.5 0 14C0 19.5 4.5 24 10 24C15.5 24 20 19.5 20 14V13H11V4Z' fill='currentColor' />
  </React.Fragment>
)
